<template>
  <div class="picturecard" :style="{ backgroundImage: 'url(' + topic.url + ')' }">
    <div class="content">
      <div class="container">
        <Title :msg="topic.title"></Title>
        <div class="row">
          <div class="col col-12 col-lg-4 col-md-6" v-for="(item, index) in word" :key="index">
            <picturecard :card="item" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title_nobg.vue';
import picturecard from '@/components/picturecard_one.vue';

export default {
  props: {
    picturecardTopic: {
      type: Object,
      default: () => ({
        title: 'Hello Pictures',
        url: 'https://picsum.photos/600/300?random=29',
      }),
    },
    picturecardWord: {
      type: Array,
      default: () => ([
        {
          title: '研究機構',
          content:
            '想知道您種的作物什麼時候能夠收成嗎？農園天眼站隨時監測記錄作物積溫、有效光照小時數與更多環境數據，協助您預計產量，並結合氣象預報，避開採收天候不佳，降損增利，讓農產更出眾。',
          picture: 'https://picsum.photos/600/300?random=30',
        },
        {
          title: '露天農田',
          content:
            '想知道您種的作物什麼時候能夠收成嗎？農園天眼站隨時監測記錄作物積溫、有效光照小時數與更多環境數據，協助您預計產量，並結合氣象預報，避開採收天候不佳，降損增利，讓農產更出眾。',
          picture: 'https://picsum.photos/600/300?random=31',
        },
        {
          title: '農場管理',
          content:
            '想知道您種的作物什麼時候能夠收成嗎？農園天眼站隨時監測記錄作物積溫、有效光照小時數與更多環境數據，協助您預計產量，並結合氣象預報，避開採收天候不佳，降損增利，讓農產更出眾。',
          picture: 'https://picsum.photos/600/300?random=32',
        },
        {
          title: '代噴業者',
          content:
            '想知道您種的作物什麼時候能夠收成嗎？農園天眼站隨時監測記錄作物積溫、有效光照小時數與更多環境數據，協助您預計產量，並結合氣象預報，避開採收天候不佳，降損增利，讓農產更出眾。',
          picture: 'https://picsum.photos/600/300?random=33',
        },
        {
          title: '履歷認證',
          content:
            '想知道您種的作物什麼時候能夠收成嗎？農園天眼站隨時監測記錄作物積溫、有效光照小時數與更多環境數據，協助您預計產量，並結合氣象預報，避開採收天候不佳，降損增利，讓農產更出眾。',
          picture: 'https://picsum.photos/600/300?random=34',
        },
        {
          title: '契作管理',
          content:
            '想知道您種的作物什麼時候能夠收成嗎？農園天眼站隨時監測記錄作物積溫、有效光照小時數與更多環境數據，協助您預計產量，並結合氣象預報，避開採收天候不佳，降損增利，讓農產更出眾。',
          picture: 'https://picsum.photos/600/300?random=35',
        },
      ]),
    },
  },
  data() {
    return {
      topic: this.picturecardTopic,
      word: this.picturecardWord,
    };
  },
  components: {
    Title,
    picturecard,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.picturecard {
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  .content {
    padding: 50px 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    .row{
      margin: auto;
      padding: 15px;
    }
    .col {
      margin: 0;
      margin-bottom: 4px;
      padding: 0;
    }
  }
}
@media screen and (max-width: 600px){
  .picturecard {
    .content {
      .container {
        padding: 0;
      }
    }
  }
}
</style>
